import * as BABYLON from '@babylonjs/core';

import computeSource from './compute-render-stars.wgsl';

function getComputeShader(engine) {
    const computeShader = new BABYLON.ComputeShader("render-stars", engine, { computeSource }, {
        bindingsMapping: {
            "params": { group: 0, binding: 0 },
            "starTex": { group: 0, binding: 2 },
            "mainTex": { group: 0, binding: 3 },
            "positions": { group: 0, binding: 4 },
            "debugVals": { group: 0, binding: 5 },
        }
    });
    return computeShader;
}

export default getComputeShader;